import React, { useState, useEffect } from 'react';
import { 
  LayoutDashboard, Package, Building2, Crown, Calculator, 
  Clock, Activity, Search, Bell, MessageCircle, CheckCircle,
  TrendingUp, ArrowUpRight, RefreshCw, MapPin,CalendarDays, UserCheck
} from 'lucide-react';

const Dashboard = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentDate, setCurrentDate] = useState('');
  const [lastSync, setLastSync] = useState('');

  useEffect(() => {
    // Fecha actual
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const dateStr = new Date().toLocaleDateString('es-PE', options);
    setCurrentDate(dateStr.charAt(0).toUpperCase() + dateStr.slice(1));
    
    // Simular última sincronización en tiempo real
    setLastSync(new Date().toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit' }));
  }, []);

  // Estadísticas principales del ecosistema DXN
  const stats = [
    {
      title: 'Catálogo de Productos',
      value: '67',
      subtitle: 'Precios y fotos vigentes',
      icon: Package,
      color: 'blue',
      bg: 'bg-blue-50',
      text: 'text-blue-600',
      border: 'border-blue-100'
    },

    {
      title: 'Centros de Servicio',
      value: '82',
      subtitle: 'Directorio activo y verificado',
      icon: Building2,
      color: 'violet',
      bg: 'bg-violet-50',
      text: 'text-violet-600',
      border: 'border-violet-100'
    },
    {
      title: 'Rangos DXN',
      value: '24',
      subtitle: 'Plan de compensación actualizado',
      icon: Crown,
      color: 'amber',
      bg: 'bg-amber-50',
      text: 'text-amber-600',
      border: 'border-amber-100'
    },
    {
      title: 'Calculadora de Puntos',
      value: 'Activa',
      subtitle: 'Cálculo automático de SV y PV',
      icon: Calculator,
      color: 'emerald',
      bg: 'bg-emerald-50',
      text: 'text-emerald-600',
      border: 'border-emerald-100'
    }
  ];

  // Feed de actividad en "tiempo real" del sistema
  const liveUpdates = [
    { id: 1, type: 'Producto', detail: 'Actualización de precio de menudeo: DXN Aloe V Aqua Gel', time: 'Hace 5 min', icon: Package, color: 'text-blue-600', bg: 'bg-blue-50' },
   // { id: 2, type: 'DNI', detail: 'Verificación de DNI', time: 'Hace 23 min', icon: MapPin, color: 'text-violet-600', bg: 'bg-violet-50' },
    { id: 2, type: 'Centro', detail: 'Verificación de horario: Centro de Servicio Los Olivos', time: 'Hace 23 min', icon: MapPin, color: 'text-violet-600', bg: 'bg-violet-50' },
    { id: 3, type: 'Sistema', detail: 'Recálculo de puntos SV/PV aplicado a nuevos ingresos', time: 'Hace 1 hora', icon: Calculator, color: 'text-emerald-600', bg: 'bg-emerald-50' },
    { id: 4, type: 'Rango', detail: 'Actualización de condiciones: Diamante Corona Ejecutivo', time: 'Hace 3 horas', icon: Crown, color: 'text-amber-600', bg: 'bg-amber-50' },
  ];

  const whatsappLink = "https://wa.me/51968039152?text=Hola%2C%20le%20escribo%20por%20la%20plataforma%20de%20DXN%2C%20quisiera%20hacer%20una%20consulta%20por%20favor.";

  return (
    <div className="p-4 lg:p-8 w-full max-w-[1600px] mx-auto space-y-6 animate-in fade-in duration-300 relative">
      
      {/* 1. Encabezado con Indicador de Tiempo Real */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
        <div>
          <div className="flex items-center gap-3 mb-1">
            <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 tracking-tight flex items-center gap-3">
              <LayoutDashboard className="w-8 h-8 text-blue-600" />
              Panel de Control DXN
            </h1>
            <span className="flex items-center gap-1.5 px-2.5 py-1 bg-emerald-50 text-emerald-700 text-xs font-bold rounded-full border border-emerald-100">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
              </span>
              En vivo
            </span>
          </div>
          <p className="text-gray-500 text-sm flex items-center gap-2 ml-11">
            <Clock className="w-4 h-4" />
            {currentDate} <span className="text-gray-300">|</span> Última sincronización: {lastSync}
          </p>
        </div>

{/*         <div className="flex items-center gap-3 w-full lg:w-auto">
          <div className="relative flex-1 lg:flex-none">
            <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input 
              type="text" 
              placeholder="Buscar producto, centro o rango..." 
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full lg:w-80 pl-10 pr-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all shadow-sm"
            />
          </div>
          <button className="p-2.5 bg-white border border-gray-200 rounded-xl text-gray-600 hover:bg-gray-50 hover:text-blue-600 transition-all shadow-sm relative">
            <Bell className="w-5 h-5" />
            <span className="absolute top-2 right-2.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white"></span>
          </button>
        </div> */}



      </div>

      {/* 2. Tarjetas de Estadísticas del Ecosistema */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm hover:shadow-md hover:border-blue-200 transition-all duration-200 group"
          >
            <div className="flex justify-between items-start mb-4">
              <div className={`p-3 rounded-xl ${stat.bg} ${stat.text} group-hover:scale-105 transition-transform duration-200`}>
                <stat.icon className="w-6 h-6" />
              </div>
              <div className="flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full bg-gray-50 text-gray-600 border border-gray-100">
                <ArrowUpRight className="w-3 h-3" />
                Actualizado
              </div>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</h3>
            <p className="text-sm font-medium text-gray-900">{stat.title}</p>
            <p className="text-xs text-gray-500 mt-1">{stat.subtitle}</p>
          </div>
        ))}
      </div>

      {/* 3. Contenido Principal Informativo */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        
        {/* Columna Izquierda: Capacidades del Sistema (2/3) */}
        <div className="lg:col-span-2 space-y-6">
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">
            <h2 className="font-bold text-gray-900 flex items-center gap-2 mb-5">
              <Activity className="w-5 h-5 text-blue-600" />
              Capacidades del Sistema en Tiempo Real
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Feature 1 */}
              <div className="p-4 rounded-xl border border-blue-100 bg-blue-50/30 hover:bg-blue-50/50 transition-colors">
                <div className="flex items-start gap-3">
                  <div className="p-2 bg-blue-100 rounded-lg text-blue-600">
                    <Package className="w-5 h-5" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 text-sm">Catálogo DXN Vivo</h4>
                    <p className="text-xs text-gray-600 mt-1 leading-relaxed">
                      Visualización instantánea de productos con precios de distribuidor, menudeo, fotos y estado de stock actualizados al momento.
                    </p>
                  </div>
                </div>
              </div>

              {/* Feature 2 */}
              <div className="p-4 rounded-xl border border-emerald-100 bg-emerald-50/30 hover:bg-emerald-50/50 transition-colors">
                <div className="flex items-start gap-3">
                  <div className="p-2 bg-emerald-100 rounded-lg text-emerald-600">
                    <Calculator className="w-5 h-5" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 text-sm">Calculadora de Puntos</h4>
                    <p className="text-xs text-gray-600 mt-1 leading-relaxed">
                      Cálculo automático y preciso de Puntos de Venta (PV) y Puntos de Volumen (SV) para cada producto y carrito de compras.
                    </p>
                  </div>
                </div>
              </div>

              {/* Feature 3 */}
              <div className="p-4 rounded-xl border border-violet-100 bg-violet-50/30 hover:bg-violet-50/50 transition-colors">
                <div className="flex items-start gap-3">
                  <div className="p-2 bg-violet-100 rounded-lg text-violet-600">
                    <Building2 className="w-5 h-5" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 text-sm">Red de Centros Vigentes</h4>
                    <p className="text-xs text-gray-600 mt-1 leading-relaxed">
                      Directorio completo con direcciones, horarios, teléfonos y responsables de cada centro de servicio verificado.
                    </p>
                  </div>
                </div>
              </div>

              {/* Feature 4 */}
              <div className="p-4 rounded-xl border border-amber-100 bg-amber-50/30 hover:bg-amber-50/50 transition-colors">
                <div className="flex items-start gap-3">
                  <div className="p-2 bg-amber-100 rounded-lg text-amber-600">
                    <Crown className="w-5 h-5" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 text-sm">Jerarquía de Rangos</h4>
                    <p className="text-xs text-gray-600 mt-1 leading-relaxed">
                      Consulta permanente de los 24 rangos DXN, desde Distribuidor hasta Embajador Corona, con sus condiciones exactas.
                    </p>
                  </div>
                </div>
              </div>


                            {/* Feature 5: Eventos DXN */}
              <div className="p-4 rounded-xl border border-rose-100 bg-rose-50/30 hover:bg-rose-50/60 transition-all duration-200 group cursor-pointer">
                <div className="flex items-start gap-3">
                  <div className="p-2 bg-rose-100 rounded-lg text-rose-600 group-hover:scale-110 transition-transform duration-200">
                    <CalendarDays className="w-5 h-5" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 text-sm">Eventos y Actividades</h4>
                    <p className="text-xs text-gray-600 mt-1 leading-relaxed">
                      Consulta los eventos en curso y el calendario de próximas actividades de la red DXN.
                    </p>
                  </div>
                </div>
              </div>

              {/* Feature 6: Consulta de DNI */}
              <div className="p-4 rounded-xl border border-indigo-100 bg-indigo-50/30 hover:bg-indigo-50/60 transition-all duration-200 group cursor-pointer">
                <div className="flex items-start gap-3">
                  <div className="p-2 bg-indigo-100 rounded-lg text-indigo-600 group-hover:scale-110 transition-transform duration-200">
                    <UserCheck className="w-5 h-5" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 text-sm">Verificación de DNI</h4>
                    <p className="text-xs text-gray-600 mt-1 leading-relaxed">
                      Valida si el socio ya posee código de registro o está disponible para nueva afiliación.
                    </p>
                  </div>
                </div>
              </div>


            </div>
          </div>

          {/* Feed de Actividad Reciente 
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
            <div className="p-5 border-b border-gray-100 flex justify-between items-center">
              <h2 className="font-bold text-gray-900 flex items-center gap-2">
                <RefreshCw className="w-5 h-5 text-blue-600" />
                Actualizaciones del Sistema
              </h2>
            </div>
            <div className="divide-y divide-gray-50">
              {liveUpdates.map((update) => (
                <div key={update.id} className="p-4 flex items-start gap-4 hover:bg-gray-50/80 transition-colors duration-150">
                  <div className={`p-2 rounded-lg ${update.bg} ${update.color} shrink-0 mt-0.5`}>
                    <update.icon className="w-4 h-4" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-0.5">
                      <span className="text-[10px] font-bold uppercase tracking-wider text-gray-400">{update.type}</span>
                      <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                      <span className="text-xs text-gray-400">{update.time}</span>
                    </div>
                    <p className="text-sm text-gray-800 font-medium">{update.detail}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>*/}



        </div>

        {/* Columna Derecha: Acciones Rápidas y Soporte (1/3) */}
        <div className="space-y-6">
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5">
            <h2 className="font-bold text-gray-900 flex items-center gap-2 mb-5">
              <TrendingUp className="w-5 h-5 text-blue-600" />
              Acceso Directo
            </h2>
            
            <div className="space-y-3">
              {[
                { title: 'Ver Productos', desc: 'Catálogo completo con precios', icon: Package, color: 'from-blue-500 to-blue-600', link: '/admin/productos' },
                { title: 'Verificacion DNI', desc: 'Verificacion codigo afiliado', icon: Package, color: 'from-blue-500 to-blue-600', link: '/admin/verificarcodigo' },
                { title: 'Centros de Servicio', desc: 'Mapa y datos de contacto', icon: Building2, color: 'from-violet-500 to-violet-600', link: '/admin/centroservicios' },
                { title: 'Rangos DXN', desc: 'Tabla de compensación', icon: Crown, color: 'from-amber-500 to-amber-600', link: '/admin/rangos' },
              ].map((action, index) => (
                <a
                  key={index}
                  href={action.link}
                  className="flex items-center gap-4 p-4 rounded-xl border border-gray-100 hover:border-blue-200 hover:bg-blue-50/40 transition-all duration-200 group"
                >
                  <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${action.color} flex items-center justify-center shadow-sm group-hover:shadow-md transition-shadow`}>
                    <action.icon className="w-5 h-5 text-white" />
                  </div>
                  <div className="flex-1">
                    <h4 className="text-sm font-bold text-gray-900 group-hover:text-blue-700 transition-colors">
                      {action.title}
                    </h4>
                    <p className="text-xs text-gray-500 mt-0.5">{action.desc}</p>
                  </div>
                  <ArrowUpRight className="w-4 h-4 text-gray-300 group-hover:text-blue-500 transition-all" />
                </a>
              ))}
            </div>
          </div>

          {/* Tarjeta de Estado del Sistema 
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-xl p-5 text-white shadow-lg relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500 opacity-10 rounded-full -mr-10 -mt-10 blur-2xl"></div>
            <div className="relative z-10">
              <div className="flex items-center gap-2 mb-3">
                <CheckCircle className="w-5 h-5 text-emerald-400" />
                <h4 className="font-bold text-sm">Sistema Operativo</h4>
              </div>
              <p className="text-xs text-slate-300 leading-relaxed mb-4">
                Todos los módulos de cálculo de PV/SV y sincronización de datos están funcionando al 100%.
              </p>
              <div className="flex items-center gap-2 text-[10px] text-slate-400 font-mono">
                <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
                v1.0.0 • Latencia: 24ms
              </div>
            </div>
          </div>*/}


        </div>
      </div>

      {/* ========================================== */}
      {/* BOTÓN FLOTANTE DE WHATSAPP (PROFESIONAL)   */}
      {/* ========================================== */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contactar soporte por WhatsApp"
        className="group fixed bottom-6 right-6 z-50 flex items-center gap-3"
      >
        {/* Tooltip */}
        <div className="hidden group-hover:flex items-center gap-2 bg-white px-4 py-2 rounded-lg shadow-xl border border-gray-100 mr-2 transition-all duration-300">
          <span className="text-sm font-semibold text-gray-800">¿Necesitas ayuda?</span>
          <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1 w-2 h-2 bg-white border-r border-b border-gray-100 transform rotate-45"></div>
        </div>

        {/* Botón */}
        <div className="relative flex items-center justify-center w-14 h-14 bg-gradient-to-br from-green-500 to-emerald-600 text-white rounded-full shadow-lg shadow-green-500/30 hover:shadow-xl hover:shadow-green-500/40 hover:scale-110 active:scale-95 transition-all duration-300">
          <MessageCircle className="w-7 h-7 group-hover:rotate-12 transition-transform duration-300" />
          <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-20 group-hover:animate-ping"></span>
        </div>
      </a>

    </div>
  );
};

export default Dashboard;